import { render, staticRenderFns } from "./portfolioE.vue?vue&type=template&id=4e93b179"
import script from "./portfolioE.vue?vue&type=script&lang=js"
export * from "./portfolioE.vue?vue&type=script&lang=js"
import style0 from "./portfolioE.vue?vue&type=style&index=0&id=4e93b179&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports